import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'reza-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  @Input()
  errorTitle: string | null = null;

  @Input()
  perex: string | null = null;

  @Input()
  text: string | null = null;

  @Input()
  image: string | null = null;
}
